import { render } from "./AdministrationDossier.vue?vue&type=template&id=454a1dcd&scoped=true"
import script from "./AdministrationDossier.vue?vue&type=script&lang=js"
export * from "./AdministrationDossier.vue?vue&type=script&lang=js"

import "./AdministrationDossier.vue?vue&type=style&index=0&id=454a1dcd&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-454a1dcd"]])

export default __exports__